// extracted by mini-css-extract-plugin
export default {"root":"DataAccess_root__MCS22","titleWrapper":"DataAccess_titleWrapper__9QaID","sections":"DataAccess_sections__5Y5Ra"};